/* istanbul ignore file */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import {
  Col, Form, Row, Table,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import ChannelService from '@avtechsoftware/ra-javascript-utilities/src/utilities/channels/ChannelService';
import ChannelType from '@avtechsoftware/ra-javascript-utilities/src/types/ChannelType';
import { parseChannelKey } from '../../../../../utility/channelUtils';

// const nonAdjustableChannelTypes = [
//   ChannelType.SWITCH.id,
//   ChannelType.ANALOG_COMPUTED.id,
//   ChannelType.FLOW.id,
//   ChannelType.SPEED.id,
//   ChannelType.PARTICULATE_MATTER.id,
//   ChannelType.PARTICULATE_TEMP_FAULT.id,
//   ChannelType.EXTREME_TEMPERATURE_FAULT.id,
//   ChannelType.ACTIVE_POWER.id,
//     ChannelType.
// ];

const adjustableChannelTypes = [
  ChannelType.TEMPERATURE.id,
  ChannelType.HUMIDITY.id,
  ChannelType.HEAT_INDEX.id,
  ChannelType.DEW_POINT.id,
  ChannelType.VOLTAGE.id,
  ChannelType.ANALOG_COMPUTED.id,
];

const SettingsMainContent = ({
  label,
  handleLabelChange,
  channelGroup,
  channelValues,
  handleAdjustChange,
  validationErrors,
  preferencesDisplay,
  readOnly,
}) => {
  const cgInstance = ChannelService.getChannelGroupTypeByValueId(
    parseChannelKey(channelGroup.channelKey).channelGroupType,
  );

  return (
    <>
      <Form.Group controlId="sensorLabel">
        <Form.Control
          type="text"
          value={label}
          onChange={(e) => handleLabelChange(e.target.value)}
          isInvalid={!!validationErrors.label}
        />
        <Form.Control.Feedback type="invalid">
          {validationErrors.label}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Text className="text-muted">
        <small className="ms-2">
          Max chars 50
        </small>
      </Form.Text>
      <Row className="my-3 ps-1">
        <Col>
          <b className="pe-2">Sensor Type</b>
          {' '}
          {cgInstance.displayName}
        </Col>
      </Row>
      <Table striped className="table">
        <thead style={{ backgroundColor: 'rgb(88, 88, 88)', color: 'white', borderBottom: 'none' }}>
          <tr>
            <th>Sensor Channel</th>
            <th>Adjustment</th>
          </tr>
        </thead>
        <tbody>
          {channelGroup.channels.map((channel) => {
            const parsedKey = parseChannelKey(channel.channelKey);
            const channelInstance = ChannelService.getChannelGroupChannel(
              parsedKey.channelGroupType, parsedKey.channelIndex, parsedKey.channelType,
            );
            const scale = preferencesDisplay.temperatureScale || 'C';
            const units = channelInstance.getUnits({ scale });
            return (
              <tr key={channel.channelKey}>
                <td>{channelInstance.displayName}</td>
                <td style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                  {adjustableChannelTypes.includes(parsedKey.channelType) && (
                  <Form.Group>
                    <div className="d-flex align-items-center">
                      <Form.Control
                        type="text"
                        className="w-75"
                        value={channelValues[channel.channelKey]}
                        onChange={(e) => handleAdjustChange(channel.channelKey, e.target.value)}
                        readOnly={readOnly}
                        disabled={readOnly}
                      />
                      <span className="ms-2">{units}</span>
                    </div>
                    <Form.Control.Feedback type="invalid" className="d-block">
                      {/* {validationErrors.channels.[channel.channelKey]?.adjust} */}
                    </Form.Control.Feedback>
                  </Form.Group>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

SettingsMainContent.defaultProps = {
  readOnly: false,
};

SettingsMainContent.propTypes = {
  label: PropTypes.string.isRequired,
  handleLabelChange: PropTypes.func.isRequired,
  channelGroup: PropTypes.object.isRequired,
  channelValues: PropTypes.object.isRequired,
  handleAdjustChange: PropTypes.func.isRequired,
  validationErrors: PropTypes.object.isRequired,
  preferencesDisplay: PropTypes.shape({
    temperatureScale: PropTypes.string,
    unitOfSpeed: PropTypes.string,
  }).isRequired,
  readOnly: PropTypes.bool,
};

export default SettingsMainContent;
